import { render, staticRenderFns } from "./VtexJob.vue?vue&type=template&id=00870770&"
import script from "./VtexJob.vue?vue&type=script&lang=js&"
export * from "./VtexJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports